import type { ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';

export const parseError = (label?: ReactNode, error?: FieldError) => {
  if (!error) {
    return;
  }

  const parsedLabel = typeof label === 'string' ? label : 'This Field';

  if (error.type === 'too_small') {
    return `${parsedLabel} is required`;
  }

  if (error.type === 'invalid_type') {
    return `${parsedLabel} is invalid`;
  }

  if (error.type === 'custom') {
    if (error.message === 'url-format') {
      return `${parsedLabel} doesn't have the right URL format`;
    }

    if (error.message === 'required') {
      return `${parsedLabel} is required`;
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error.type === 'too_big') {
    return `${parsedLabel} is too long`;
  }

  if (error.type === 'invalid_string') {
    if (error.message?.includes('email')) {
      return `${parsedLabel} must be a valid email`;
    }
    if (error.message?.includes('url')) {
      return `${parsedLabel} must be a valid URL`;
    }
    return `${parsedLabel} is invalid`;
  }

  if (error.message) {
    return error.message;
  }

  return `${parsedLabel} is invalid`;
};
